import React from 'react';
import PropTypes from 'prop-types';
import { Table, Column } from '../Common';
import Routes from '../../routes';
import '../Common/Common.css';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import PlagiarismIcon from '@mui/icons-material/Plagiarism';

const LocationRegistration = ({
    id, // locationID
    refreshData,
    onEdit,
    onDelete,
    onDocumentClick
}) => (
    <Table
        url={Routes.Location.LocationRegistrationTable(id)}
        refresh={refreshData}
        tableHeader="Registrations"
        tableHeaderTooltipText="A location's different registrations can be added and dates tracked into Trakref"
        noResultText="Oops...It is empty here..."
        noResultText2="Create a new Location Registration to get started."
        rowActions={[
            {
                icon: (_) => PlagiarismIcon,
                toolTip: "View Attachments",
                onClick: (row) => onDocumentClick(row),
                isVisible: (_) => true,
                disabled: (row) => !row.hasFile,
            },
            {
                icon: (_) => EditIcon,
                toolTip: "Edit Location Registration",
                onClick: (row) => onEdit(row),
                isVisible: (_) => true
            },
            {
                icon: (_) => DeleteIcon,
                toolTip: "Delete Location Registration",
                onClick: (row) => onDelete(row),
                isVisible: (_) => true
            },
        ]}
    >
        <Column id='idHeader' property="registrationID" title="ID" visible={false} />
        <Column id='idRegistrationTypeID' property="registrationTypeID" title="regTypeID" visible={false} />
        <Column id='locationRegistrationTypeName' title="Location Registration Type" property="locationRegistrationTypeName" />
        <Column id='facilityId' property="facilityID" title="Facility ID" />
        <Column id='startDate' title="Start Date" property="startDate" type="dateTime" />
        <Column id='endDate' title="End Date" property="endDate" type="dateTime" />
        <Column id='createdBy' title="Created By" property="createdBy" />
        <Column id='creationDate' title="Creation Date" property="creationDate" type="dateTime" />
    </Table>
);

LocationRegistration.propTypes = {
    id: PropTypes.string.isRequired,
    refreshData: PropTypes.any.isRequired
};

export default LocationRegistration;
